/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Visibilityorganization1Inputs */

const zh_share_visibilityorganization1 = /** @type {(inputs: Share_Visibilityorganization1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组织`)
};

const en_share_visibilityorganization1 = /** @type {(inputs: Share_Visibilityorganization1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization`)
};

const es_share_visibilityorganization1 = /** @type {(inputs: Share_Visibilityorganization1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organización`)
};

/**
* | output |
* | --- |
* | "Organization" |
*
* @param {Share_Visibilityorganization1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const share_visibilityorganization1 = /** @type {((inputs?: Share_Visibilityorganization1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Visibilityorganization1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_visibilityorganization1(inputs)
	if (locale === "en") return en_share_visibilityorganization1(inputs)
	return es_share_visibilityorganization1(inputs)
});
export { share_visibilityorganization1 as "share_visibilityOrganization" }